import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton, Tooltip } from "@mui/material";

import {
  PaymentDataBaseIcon,
  PaymentMoneyIcon,
  PaymentArrowCircleDownLeftIcon,
  PaymentBankIcon,
  PaymentOverViewTooltipIcon,
} from "../../../../../assets/icons/MUI/PaymentIcons";

const SummaryCard = ({ summary: { key, amount } }: { summary: { key: string; amount: number } }) => {
  const { t } = useTranslation();

  const iconMap = {
    totalTransferred: PaymentDataBaseIcon,
    pendingToUser: PaymentArrowCircleDownLeftIcon,
    paidToUser: PaymentMoneyIcon,
    platformCommission: PaymentBankIcon,
  };

  const tooltipMap = {
    totalTransferred: PaymentOverViewTooltipIcon,
    pendingToUser: PaymentOverViewTooltipIcon,
    paidToUser: PaymentOverViewTooltipIcon,
    platformCommission: PaymentOverViewTooltipIcon,
  };

  const Icon = key && iconMap[key as keyof typeof iconMap];

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        background: "var(--Gray-White, #FFF)",
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "16px",
        gridColumn: "span 1",
        gridRow: "span 1",
      }}
    >
      {Icon && <Icon />}
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px" }}>
        <Typography
          component="span"
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "30px",
          }}
        >
          {`${amount / 100} EGP`}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "4px", justifyContent: "space-between" }}>
          <Typography
            component="span"
            sx={{
              color: "var(--Dark---600, #707070)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            {t(`pages.payment.overview.dashboard.${key}`)}
          </Typography>
          {tooltipMap[key as keyof typeof tooltipMap] && (
            <Tooltip title={t(`pages.payment.overview.dashboard.tooltip.${key}`)}>
              <span style={{ display: "inline-flex", cursor: "help" }}>
                <PaymentOverViewTooltipIcon />
              </span>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SummaryCard;

export const SummaryCardLoading = () => {
  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        background: "var(--Gray-White, #FFF)",
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "16px",
        gridColumn: "span 1",
        gridRow: "span 1",
      }}
    >
      <Skeleton variant="rounded" width={56} height={56} />
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px" }}>
        <Skeleton variant="text" width={80} height={30} />
        <Skeleton variant="text" width={120} height={20} />
      </Box>
    </Box>
  );
};
